<template>

  <section class="dashboard">
    <DashboardTitle
      title="Cuenta Virtual"
      description="Este es el estado de Cuenta Virtual asociado a tus
        inversiones en Ekscelenko de Cumplo. Aquí podrás revisar tu saldo y hacer
        movimientos como retiros y depósitos.">
    </DashboardTitle>
    <transition name="fade" mode="out-in">
      <Preloader v-if="!viewIsReady"></Preloader>
    </transition>
      <div v-if="viewIsReady">
        <div class="container">
          <p class="withdrawal-advice -centered-info">
            *Recuerda que al hacer retiros de dinero antes de las 16:00 hrs,
            este se verá reflejado en tu cuenta bancaria después de las 16:01
            del mismo día hábil. <br>
            O bien, si la solicitud de retiro se hace después de las 16:00 hrs,
            este se verá reflejado hasta el día siguiente hábil después de las
            16:01 hrs hora del centro de México.
          </p>
        </div>
        <DashboardBalanceResume></DashboardBalanceResume>
<!--
        <div class="box-filters -margin-bottom-2">
          <div class="row-responsive">
            <div class="column column-sm-100">
              <div class="modal-investment-buttons -centered-info">
                <button
                  class="button button-block"
                  @click="$modal.show('virtualaccounts-credits')">
                  <img src="/static/svg/icon_octicon-sign-in.svg"
                  class="button-icon">
                  Depositar a Cuenta Virtual
                </button>
                <button
                  class="button button-block"
                  @click = "isWithdrawal = !isWithdrawal"
                  >
                  <img src="/static/svg/icon_octicon-sign-out.svg"
                  class="button-icon">
                  {{!this.isWithdrawal ? "Retiros Cuenta Virtual" : "Volver a lista de transacciones"}}
                </button>
              </div>
            </div>
          </div>
        </div>
-->
        <div v-if="!isWithdrawal">
          <DashboardVirtualAccountsDateFilter
            class="-margin-top-3 -margin-left-2"
            v-on:requiredParams="getTransactions"
            v-if="!hideFilter">
          </DashboardVirtualAccountsDateFilter>
          <DashboardVirtualAccountsTable
            :object="virtualAccoutsList"
            v-if="!emptyTransactions">
          </DashboardVirtualAccountsTable>
        </div>
        <div v-else class="-margin-top-3 -margin-left-2">
          <DashboardVirtualAccountsWithdrawal>
          </DashboardVirtualAccountsWithdrawal>
        </div>
      </div>
        <div v-if="!isWithdrawal">
          <div class="box-no-investments -centered-info" v-if="emptyTransactions && !comeFromFilter">
            <h4 class="maintitle">No tienes transacción en alguna cuenta virtual</h4>
<!--
            <router-link
              class="button"
              :to="{ name: 'Home' }">
              Revisa las oportunidades de inversión activas
            </router-link>
-->
          </div>
          <div class="box-no-investments -centered-info" v-if="emptyTransactions && comeFromFilter">
            <p class="maintitle">No se encontraron movimientos en ese intervalo de fechas. Prueba con otras fechas</p>
      </div>
      </div>
    <modal
      name="virtualaccounts-credits"
      classes="modal-investment v--modal-box v--modal"
      height="auto" width="100%" :maxWidth="600" :adaptive="true">
      <DashboardVirtualAccountsModalCredit>
      </DashboardVirtualAccountsModalCredit>
    </modal>
  </section>

</template>

<script>

import DashboardVirtualAccountsTable
  from '@/views/dashboardVirtualAccount/DashboardVirtualAccountsTable'
import DashboardVirtualAccountsModalCredit
  from '@/views/dashboardVirtualAccount/DashboardVirtualAccountsModalCredit'
import DashboardVirtualAccountsDateFilter
  from '@/views/dashboardVirtualAccount/DashboardVirtualAccountsDateFilter'
import DashboardVirtualAccountsWithdrawal
  from '@/views/dashboardVirtualAccount/DashboardVirtualAccountsWithdrawal'
import DashboardBalanceResume from '@/components/DashboardBalanceResume'
import Preloader from '@/components/Preloader'
import DashboardTitle from '@/components/SignedTitle'

import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'DashboardVirtualAccount',
  metaInfo () {
    return {
      title: 'Cuenta Virtual'
    }
  },
  components: {
    Preloader,
    DashboardTitle,
    DashboardBalanceResume,
    DashboardVirtualAccountsTable,
    DashboardVirtualAccountsModalCredit,
    DashboardVirtualAccountsDateFilter,
    DashboardVirtualAccountsWithdrawal
  },
  mixins: [httpRequestMixin],
  data () {
    return {
      viewIsReady: false,
      emptyTransactions: false,
      virtualAccoutsList: [],
      comeFromFilter: true,
      hideFilter: false,
      isWithdrawal: false
    }
  },
  created: async function () {
    this.getTransactions({
      min_date: '',
      max_date: '',
      comeFromFilter: false
    })
  },
  methods: {
    getTransactions: async function (params) {
      const minDate = params['min_date']
      const maxDate = params['max_date']
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investors/transactions/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          min_date: minDate,
          max_date: maxDate
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.virtualAccoutsList = response.data.balance
          if (this.virtualAccoutsList.length === 0) {
            this.hideFilter = !params['comeFromFilter']
            this.comeFromFilter = params['comeFromFilter']
            this.emptyTransactions = true
          } else {
            this.emptyTransactions = false
          }
          this.viewIsReady = true
        }
      }
    }
  }
}

</script>

<style lang="scss">

.-margin-top-3 {
  margin-top: 3rem;
}

.withdrawal-advice {
  margin-top: 3rem;
  padding: 2rem;
  font-size: .7em;
  font-style: italic;
  background-color: #eee;
  border-radius: 4px;
}

.modal-investment .modal-content .title {
  float: none;
  margin: .5rem 0 0;
  max-width: 85%;
  font-weight: 300;
  font-size: 1.3em;
}

.-legend {
  font-size: .85em;
  font-style: italic;
}

.modal-investment-buttons {
  text-align: center;

  &.-align-right {
    text-align: right;
  }

  .button {
    width: 100%;

    > img {
      vertical-align: middle;
    }
  }

  @media (min-width: 42rem) {
    .button {
      width: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/DashboardVirtualAccount.vue